<main class="mat-body">
    <div class="container progress-bar-wrapper">
        <div class="row">
            <div class="col-12">
                <thr-contract-progress-disinvestment [percent]="100"></thr-contract-progress-disinvestment>
            </div>
        </div>
    </div>

    <div class="container" *ngIf="contract">
        <div class="row">
            <div class="col-12 pt-3">
                <div class="row">
                    <div class="col-12">
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'operative.sign'|translate"></h1>
                    </div>
                </div>
                <hr class="mt-1 mb-3" />

                <div class="row">
                    <div class="col-12 col-sm-5">
                        <label>{{ 'product.order'|translate }}</label>
                        <h2 class="mat-title text-blue font-weight-bold mb-0">{{ 'disinvestment.title'|translate }}</h2>
                    </div>
                    <div class="col-12 col-sm-7 mt-3 mt-sm-0">
                        <label>{{ 'operative.contract-code'|translate }}</label>
                        <h2 class="mat-title text-blue font-weight-bold mb-0">{{ contract.bankCode }}</h2>
                    </div>
                </div>
                <hr class="mt-3 mb-5" />

                <form #formDisinvestmentSign="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
                    <thr-operate-form-sign
                        [signedBy]="signedBy"
                        [allowHandwritten]="false"
                        [participants]="participants"
                    ></thr-operate-form-sign>

                    <div class="row justify-content-end">
                        <div class="col-12 col-sm-6 col-md-4">
                            <button
                                type="submit"
                                class="full-width mat-elevation-z0"
                                mat-raised-button
                                color="blue"
                                [disabled]="!formDisinvestmentSign.valid"
                            >
                                {{ 'general.sign'|translate }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</main>
